import { render, staticRenderFns } from "./UploadNationalIdCard.vue?vue&type=template&id=a04918e8&scoped=true&"
import script from "./UploadNationalIdCard.vue?vue&type=script&lang=js&"
export * from "./UploadNationalIdCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadNationalIdCard.vue?vue&type=style&index=0&id=a04918e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04918e8",
  null
  
)

export default component.exports